<template>
  <div id="changePasswordRoot">
   <div id="changePasswordContainer">
      <div id="cpTitleDiv">
        <div id="cpBackImgParent">
          <img id="cpBackImg" src="~assets/img//rebate-center/left_back_arrow_grey.png" @click="hideChangePasswordPage()"/>
        </div>
        <div id="cpTitleParent"><label>修改密码</label></div>
      </div>
      <div id="cpShowPhone">
          已绑定手机：{{$store.state.commonParameters.phone}}
      </div>
      <div id="cpPwOneParent">
        <div id="cpPwOneLockParent">
          <img id="cpLockOne" src="~assets/img//rebate-center/lock.png"/>
        </div>
        <input id="cpPwOneInput" placeholder="请输入6~12位新密码(字母或数字)" v-model="pwOne"/>
      </div>
      <HR style="border:1 dashed #987cb9;" width="95%" color=gray SIZE=1></HR>
      
      <div id="cpPwTwoParent">
        <div id="cpPwTwoLockParent">
          <img id="cpLockTwo" src="~assets/img//rebate-center/lock.png"/>
        </div>
        <input id="cpPwTwoInput" placeholder="请再次输入新密码(字母或数字)" v-model="pwAgain"/>
      </div>
      <HR style="border:1 dashed #987cb9;" width="95%" color=gray SIZE=1></HR>
      
      <div id="cpCodeParent">
        <div id="cpCodeMessageParent">
          <img id="cpMessage" src="~assets/img//rebate-center/lock.png"/>
        </div>
        <input id="cpCodeInput" placeholder="请输入验证码" v-model="verifyCode"/>
        <span v-if="!show"><button id="cpFetchCodeBtn" style="background-color: gray;">已发送({{count}})</button></span>
        <span v-else><button id="cpFetchCodeBtn" @click="getCode">获取验证码</button></span>

        <!-- <span v-show="show" @click="getCode">获取验证码</span>
        <span v-show="!show" class="count">{{count}} s</span> -->
      </div>
      <HR style="border:1 dashed #987cb9;" width="95%" color=gray SIZE=1></HR>

      <button id="cpModify" @click="modifyPassword()">修改</button>
   </div>
   
    
  </div>
 </template>
 
 <script>
 import getRequestParams from "@/signParams";
 import { request } from 'network/request';
  export default {
    data () {
      return {
        pwOne: "",
        pwAgain: "",
        verifyCode: "",
        times:60,
        start:false,
        timeClock:null,
        show: true,
        count: '',
        timer: null
      }
    },
    components: {
 
    },
    methods:{
      getCode(){
        if (this.pwOne.length < 5 || this.pwOne.length > 13) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入6~12位的密码"});
          return;
        }
        if (this.pwAgain.length < 5 || this.pwAgain.length > 13) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入6~12位的确认密码"});
          return;
        }

        let containSpecial = RegExp(/[(\ )(\~)(\~)(\!)(\！)(\@)(\#)(\$)(\￥)(\%)(\^)(\……)(\&)(\*)(\()(\（)(\))(\）)(\-)(\_))(\——)(\+)(\=)(\[)(\【)(\])(\】)(\{)(\})(\|))(\、))(\)(\\)(\;)(\；)(\:)(\：)(\')(\‘)(\’)(\")(\“)(\”)(\,)(\，)(\.)(\。)(\/)(\《)(\<)(\>)(\》)(\?)(\？)(\)]+/);
        if (containSpecial.test(this.pwOne)) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "密码不能含有特殊字符！"});
          return;
        }
        if (containSpecial.test(this.pwAgain)) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "确认密码不能含有特殊字符！"});
          return;
        }

        if (this.pwAgain !== this.pwOne) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "两次密码输入不正确"});
          return;
        }
        const TIME_COUNT = 60;
        this.count = TIME_COUNT;
        this.show = false;
        let storeCommomParams = this.$store.getters.getCommomParams;
        // type 验证码类型，“free”为登录，“bind”为绑定手机，“unbind”为解绑手机，“register”为注册，“find”为修改密码
        let sendReqParams = getRequestParams({"type": "find"},storeCommomParams);
        request({
          url:this.urls.REBATE_SEND,
          params: {
            data: sendReqParams
          },
        }).then(res =>{
          // 开始倒计时
          if (!this.timer) {
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                }
              }, 1000)
            }
        });

      } ,
      hideChangePasswordPage(){
        this.$emit("setHideChangePasswordPage")
      },
      modifyPassword(){
        if (this.pwOne.length < 5 || this.pwOne.length > 13) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入6~12位的密码"});
          return;
        }
        if (this.pwAgain.length < 5 || this.pwAgain.length > 13) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入6~12位的确认密码"});
          return;
        }

        let containSpecial = RegExp(/[(\ )(\~)(\~)(\!)(\！)(\@)(\#)(\$)(\￥)(\%)(\^)(\……)(\&)(\*)(\()(\（)(\))(\）)(\-)(\_))(\——)(\+)(\=)(\[)(\【)(\])(\】)(\{)(\})(\|))(\、))(\)(\\)(\;)(\；)(\:)(\：)(\')(\‘)(\’)(\")(\“)(\”)(\,)(\，)(\.)(\。)(\/)(\《)(\<)(\>)(\》)(\?)(\？)(\)]+/);
        if (containSpecial.test(this.pwOne)) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "密码不能含有特殊字符！"});
          return;
        }
        if (containSpecial.test(this.pwAgain)) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "确认密码不能含有特殊字符！"});
          return;
        }

        if (this.pwAgain !== this.pwOne) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "两次密码输入不正确"});
          return;
        }
        if (this.verifyCode.length < 1) {
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入验证码"});
          return;
        }
        // 修改密码
        let storeCommomParams = this.$store.getters.getCommomParams;
        let editPasswordReqParams = getRequestParams(
          {
            "password":this.pwOne,
            "repassword":this.pwAgain,
            "verify":this.verifyCode,
          },
          storeCommomParams);
        request({
          url:this.urls.REBATE_EDITPASSWORD,
          params: {
            data: editPasswordReqParams
          },
        }).then(res =>{
          // 修改密码成功
          this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "修改密码成功"});
          this.$emit("setHideChangePasswordPage");
        });
      }
    }
  }
 </script>
 
 <style>
 #changePasswordRoot{
     /* display: none; */
     width: 100%;
     height: 100%;
     position: fixed;
     top: 0;
     left: 0;
     background: rgba(51,51,51,0.5);
     z-index: 133;
   }
   #changePasswordContainer{
     width: 300px;
     height: 280px;
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translate(-50%, -50%);
     background: #fff;
     z-index: 155;
     border-radius: 10px 10px 10px 10px;
   }
   #cpTitleDiv{
    display: flex;
    margin-top: 20px;
   }

   #cpBackImgParent{
    position: relative;
   }
   
   #cpBackImg{
    margin-left: 20px;
    position: relative;
    height: 30px;
    width: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform:translate(-50%,-50%);
    /* background-color: aqua; */
   }
   
  #cpTitleParent{
    flex: 3;
    position: relative;
  }
  
  #cpTitleParent label{
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform:translate(-50%,-50%);
    font-weight: bold;
    font-size: large;
  }
  #cpShowPhone{
    width: 100%;
    margin-top: 20px;
    position: absolute;
    text-align: center;
    font-size: smaller;
  }

  #cpPwOneParent{
    /* clear: both; */
    position: relative;
    display: flex;
    margin-top: 60px;
  }
  #cpLockOne{
    margin-left: 10px;
    height: 20px;
    width: 20px;
    /* position: absolute; */
  }
  /* 第一次输入密码 */
  #cpPwOneInput{
    padding-left: 5px;
    outline: none;
    border: none;
    font-size: x-small;
    width: 78%;
  }
  #cpPwTwoParent{
    /* clear: both; */
    position: relative;
    display: flex;
    margin-top: 20px;
  }
  #cpLockTwo{
    margin-left: 10px;
    height: 20px;
    width: 20px;
    /* position: absolute; */
  }
  /* 第2次输入密码 */
  #cpPwTwoInput{
    padding-left: 5px;
    outline: none;
    border: none;
    font-size: x-small;
    width: 78%;
  }

  #cpCodeParent{
    /* clear: both; */
    position: relative;
    display: flex;
    margin-top: 20px;
  }
  #cpMessage{
    margin-left: 10px;
    height: 20px;
    width: 20px;
    /* position: absolute; */
  }
  /* 获取验证码 */
  #cpCodeInput{
    padding-left: 5px;
    outline: none;
    border: none;
    font-size: x-small;
  }
  #cpFetchCodeBtn{
    background-color: red;
    color: white;
    border: none;
    border-radius: 5px 5px 5px 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: x-small;
    float: right;
    width: auto;
  }

  #changePasswordContainer HR{
    margin-left: 10px;
    width: 90%;
    transform: scaleY(0.2);
  }

  
  #cpModify{
    text-align: center;
    position: absolute;
    top: 88%;
    left: 50%;
    transform:translate(-50%,-50%);
    border-radius: 5px 5px 5px 5px;
    background-color: red;
    color: white;
    border: none;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
 </style> 


// WEBPACK FOOTER //
// src/views/MineView/ChangePassword.vue